import React from 'react'

import PropTypes from 'prop-types'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'

import styles from './duplicatePaymentModal.module.scss'

const DuplicatePaymentModal = ({ closeFunc }: any) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Duplicate Payment</h1>
      <h3>
        Your payment request was not processed because a previous request for the same client and session date has
        already been submitted.
      </h3>
      <p className={styles.questions}>
        For any questions, please contact <a href='mailto:providers@lyrahealth.com'>providers@lyrahealth.com</a>.
      </p>
      <PrimaryButton onClick={() => closeFunc()}>OK</PrimaryButton>
    </div>
  )
}

DuplicatePaymentModal.propTypes = {
  closeFunc: PropTypes.func.isRequired,
}

export default DuplicatePaymentModal
